import { useMissionsTranslation } from '../../../../ui/hooks';
import { convertMillisecondsToHours } from '../../../../ui/utils/convertMillisecondsToHours';
import { toKebabCase } from '../../../../ui/utils/toKebabCase';
import { TransparentBox } from '@juvare/common-web-ui/TransparentBox';
import { Box, Typography } from '@mui/material';
import React from 'react';
export const TimeTrackingPlaceholders = ({ approvedMissions, approvedShifts, approvedHours }) => {
    const { t } = useMissionsTranslation();
    const placeholdersDetails = [
        {
            label: t('missions.missions'),
            count: approvedMissions,
            dataTest: 'total-missions-transparent-box',
        },
        {
            label: t('shifts.title'),
            count: approvedShifts,
            dataTest: 'total-shifts-transparent-box',
        },
        {
            label: t('common.Hours'),
            count: convertMillisecondsToHours(approvedHours),
            dataTest: 'total-hours-transparent-box',
        },
    ];
    return (React.createElement(Box, { sx: { display: 'flex', gap: { xs: 2, lg: 3 }, width: { md: '100%', lg: '80%' }, flexDirection: { xs: 'column', sm: 'row' } }, "data-test": 'time-tracking-placeholders' }, placeholdersDetails.map((placeholder) => (React.createElement(Box, { key: placeholder.label, sx: { width: '100%' } },
        React.createElement(TransparentBox, { "data-test": placeholder.dataTest },
            React.createElement(Box, { sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                }, "data-test": `${toKebabCase(placeholder.label)}-analytics` },
                React.createElement(Typography, { component: 'p', variant: 'h4', sx: { wordWrap: 'break-word' } }, placeholder.count),
                React.createElement(Typography, { variant: 'body2', sx: { wordWrap: 'break-word' } }, placeholder.label))))))));
};
